module.exports = __webpack_public_path__ + "static/media/search-dollar.e47f80d6.svg";